export const selectedAddress = (state) => {
    let address = null;
    const selectedAddressId = state.form.addressList;
    if (selectedAddressId == -1 || (state.gas && state.gas.parcel && state.gas.parcel.addressList[0].id == -1)) {
        address = {
            isPoBox: false,
            unitNumber: state.form.siteAddress_unitNumber,
            streetNumber: state.form.siteAddress_streetNumber,
            streetName: state.form.siteAddress_streetName,
            streetType: state.form.siteAddress_streetType || "",
            streetDirection: state.form.siteAddress_streetDirection || "",
            city: state.form.siteAddress_city,
            province: "BC",
            postCode: state.form.siteAddress_zip,
            poBox: null,
            country: "CA"
        };
    }
    else if (state.gas && state.gas.parcel) {
        if(state.gas.isResume) { // resume case
             address = {
            isPoBox: false,
            unitNumber: state.form.siteAddress_unitNumber,
            streetNumber: state.form.siteAddress_streetNumber,
            streetName: state.form.siteAddress_streetName,
            streetType: state.form.siteAddress_streetType || "",
            streetDirection: state.form.siteAddress_streetDirection || "",
            city: state.form.siteAddress_city,
            province: "BC",
            postCode: state.form.siteAddress_zip,
            poBox: null,
            country: "CA"
        };
        }
        else {
            state.gas.parcel.addressList.map((x) => {
                if (x.id == selectedAddressId) {
                    address = x.address;
                    if (state.form.unitNumber)
                        address = { ...address, unitNumber: state.form.unitNumber };
                }
            });
        }
    }
    return address;
};
export const duplexAddress = (state) => {
    return {
        isPoBox: false,
        unitNumber: state.form.duplexSecondAddress_unitNumber,
        streetNumber: state.form.duplexSecondAddress_streetNumber,
        streetName: state.form.duplexSecondAddress_streetName,
        streetType: state.form.duplexSecondAddress_streetType || "",
        streetDirection: state.form.duplexSecondAddress_streetDirection || "",
        city: state.form.duplexSecondAddress_city,
        province: "BC",
        postCode: state.form.duplexSecondAddress_zip,
        poBox: null,
        country: "CA"
    };
};
